import React from 'react';
import { Typography, Grid } from '@mui/material';

import img1 from '../../assets/maestria1.webp'

const CourseDetails = () => {
  return (
    <>
      <Grid
        container
        spacing={3}
        sx={{
          padding: { xs: '20px', sm: '30px', md: '40px' }, // Ajuste dinámico del padding
          maxWidth: '1200px', // Establece el ancho máximo
          mx: { xs: '', sm: '20px', md: 'auto' }, // Márgenes horizontales dinámicos
        }}
      >
        <Grid item xs={12} sm={6}>
          <img
            src= {img1}
            alt="Programación Web"
            style={{
              width: '100%',
              borderRadius: '10px',
              boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.1)',
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 'bold',
              color: '#2c3e50',
              marginBottom: { xs: '10px', sm: '20px' },
              fontSize: { xs: '1.2rem', sm: '2rem' },
            }}
          >
            ¿Qué aprenderás?
          </Typography>
          <ul
            style={{
              fontSize: '0.9rem',
              color: '#7f8c8d',
              lineHeight: '1.5',
              marginBottom: '20px',
              paddingLeft: '20px',
            }}
          >
            <li>Ingresara a la comundad cientifica creadora de conocimiento </li>
            <li>Fortalecera su pensamiento critico y su vision medica.</li>
            <li>Se especializara sobre una rama en particular del diagnostico ultrasonografico.</li>
            <li>Determinara con mayor presicion la patologia observada en los hayazgos ultrazonograficos y valorara las vias de accion y tratamientos a seguir al respecto</li>
          </ul>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 'bold',
              color: '#2c3e50',
              marginBottom: { xs: '10px', sm: '20px' },
              fontSize: { xs: '1.2rem', sm: '2rem' },
            }}
          >
            Requisitos
          </Typography>
          <ul
            style={{
              fontSize: '0.9rem',
              color: '#7f8c8d',
              lineHeight: '1.5',
              marginBottom: '20px',
              paddingLeft: '20px',
            }}
          >
            <li>Licenciatura en medicina.</li>
            <li>Tener acreditado "DIPLOMADO BÁSICO EN ULTRASONIDO DIAGNÓSTICO PARA MÉDICOS GENERALES Y DIVERSOS ESPECIALISTAS".</li>
          </ul>
        </Grid>
      </Grid>
    </>
  );
};

export default CourseDetails;